<div class="content">
    @if (bottomNavigation) {
        <div class="list list-card">
            <ms-item icon="theme-search" (click)="redirectToSearch()">
                <span item-title>
                    {{ sitecore.globalMessages.Search }}
                    @if (showNewBadge) {
                        <span class="search-new-badge">{{ sitecore.betBuilder.messages?.NewBadge }}</span>
                    }
                </span>
            </ms-item>
        </div>
    }
    @if (isMobileLayout && calendarIntervals.length) {
        <ms-heading class="time-frame-header" [title]="sitecore.globalMessages.TimeFrames" />
    }
    @if (isMobileLayout && calendarIntervals.length) {
        <ms-calendar-item-list [calendarIntervals]="calendarIntervals" [location]="timeFrameLocation" />
    }
    @if (topGroup && top.length) {
        <ms-sport-list trackingPrefix="AZMenu_TopSports" [sports]="top" [title]="sitecore.event.TopSports" [crmPromoted]="crmPromotedSportsMap" />
    }
    @if (groups && groups.length) {
        @if (!topGroup && bottomNavigation) {
            <ms-heading [title]="sitecore.event.AZsports" />
        }
        @for (group of groups; track group.group) {
            @if (group.sports && group.sports.length) {
                <ms-sport-list
                    trackingPrefix="AZMenu_AZSports"
                    class="sport-list"
                    [sports]="group.sports"
                    [title]="group.group"
                    [crmPromoted]="crmPromotedSportsMap" />
            }
        }
    }
</div>
